export const Gantt = () => {
  return <div> Gantt</div>
}